import { AbstractPersistentEvent } from '@trustedshops/tswp-core-common';

export interface VisibilityGuardFactory {
  create(...args: any[]): AbstractPersistentEvent<boolean>;
}
